const DefaultCacheState = {
    payload: {
        initialLoading: true,
        flashMessage: null,
        error: "",
        success: "",
    },
    params: {
        per_page: 25,
        page: 1,
        order: 'desc',
        sort_id: `id`,
        q: ``,
    },
    site_id: ``,
    redirects:{
        mode:'',
    }
}

export const RedirectsState = {data: DefaultCacheState}